/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IReplayNextPlayerInteraction, ISerialData} from "./ISerialData";
import {SerialDataParser} from "./SerialDataParser";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SerialGameConfig} from "../../SerialGameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SerialGameMode} from "../SerialGameMode";

export abstract class SerialParsedData {

    public readonly mode:string;
    public readonly nextMode:string;
    public readonly fullReels:string[][];
    public readonly reels:string[][];
    public readonly enhancerReelsOpenedNextSpin:boolean[][];
    public readonly totalWin:number;
    public readonly scatterPositions:number[];
    public readonly nextSpinPositions:boolean[][];
    public readonly freespinsLeft:number;
    public readonly freespinTriggeredThisSpin:boolean;
    public readonly addedNumberOfFreespinsThisSpin:number;
    public readonly numberOfFreespinsPlayed:number;
    public readonly replayNextPlayerInteraction:IReplayNextPlayerInteraction | undefined;
    public readonly showTotalWin:boolean;
    public readonly lockedSymbolsNextSpin:string[][];
    public readonly multiplierOnReel:number[];
    public readonly maxWinLevel:number;
    public readonly evaluatedArea:string[][];
    public readonly symbolSizes:number[][];

    constructor(rawData:ISerialData, parser:SerialDataParser) {
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        this.reels = parser.parseReels(rawData);
        this.fullReels = this.parseFullReels(rawData);
        this.evaluatedArea = rawData.evaluatedArea;
        this.enhancerReelsOpenedNextSpin = parser.parseEnhancerReelsOpenedNextSpin(rawData);
        this.totalWin = rawData.accumulatedRoundWin != null ? rawData.accumulatedRoundWin : 0;
        this.scatterPositions = this.parseScatterPositions(rawData);
        this.freespinTriggeredThisSpin = !this.mode.includes(GameMode.FREESPIN) && this.nextMode.includes(GameMode.FREESPIN);
        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.addedNumberOfFreespinsThisSpin = rawData.addedNumberOfFreespinsThisSpin != null ? rawData.addedNumberOfFreespinsThisSpin : 0;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.lockedSymbolsNextSpin = rawData.lockedSymbolsNextSpin;
        this.nextSpinPositions = this.parseNextSpinPositions(rawData.lockedSymbolsNextSpin);
        this.showTotalWin = true;
        this.replayNextPlayerInteraction = SlotGame.apiPlugin.isReplay ? rawData.nextPlayerInteraction : undefined;
        this.multiplierOnReel = rawData.multiplierOnReel.concat();
        this.symbolSizes = rawData.symbolSizes;
        this.maxWinLevel = rawData.maxWinLevel;
    }

    protected parseScatterPositions(rawData:ISerialData):number[] {
        return ArrayHelper.initArrayWithValues(5, reelId => -1);
    }

    private parseFullReels(rawData:ISerialData):string[][] {
        const result:string[][] = ArrayHelper.initArrayWithValues<string[]>(SerialGameConfig.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<string>(7, () => "")
        });

        this.reels.forEach((reel, reelId) => {
            result[reelId][0] = rawData.topRowReelString[reelId][0];
            result[reelId][1] = rawData.topRowReelString[reelId][1];
            result[reelId][2] = reel[1];
            result[reelId][3] = reel[2];
            result[reelId][4] = reel[3];
            result[reelId][5] = rawData.bottomRowReelString[reelId][0];
            result[reelId][6] = rawData.bottomRowReelString[reelId][1];
        });

        return result;
    }

    private parseNextSpinPositions(lockedSymbolNextSpin:string[][]):boolean[][] {
        const result:boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(SerialGameConfig.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<boolean>(7, () => true)
        });

        if(this.mode === SerialGameMode.CAPWIN_GAME) {
            return result;
        }

        lockedSymbolNextSpin.forEach((lockedReel, reelId) => {
            lockedReel.forEach((lockedSym, symId) => {
                if(lockedSym) {
                    result[reelId][symId] = false;
                }
            })
        });

        return result;
    }
}